export default __webpack_public_path__ + "static/media/black-headphone.3e98a567.png";